var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Checkbox, FormControlLabel, Stack, FormLabel, Button, FormControl, InputLabel, Select, MenuItem, TextField, Grid } from '@mui/material';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, Modifier } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
var SignatureSettingsEditor = /** @class */ (function (_super) {
    __extends(SignatureSettingsEditor, _super);
    function SignatureSettingsEditor(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        var signingText = (_b = (_a = props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null || _b === void 0 ? void 0 : _b.signingText;
        var signatures = (_c = _this.props.signingStore) === null || _c === void 0 ? void 0 : _c.parseSignatures(signingText);
        var selectedSignature;
        if (signatures && signatures.length > 0) {
            selectedSignature = signatures[0];
        }
        _this.state = {
            signatureEditorState: _this.getEditorState(selectedSignature),
            selectedSignatureName: selectedSignature ? selectedSignature.name : ''
        };
        return _this;
    }
    Object.defineProperty(SignatureSettingsEditor.prototype, "getEditorState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (signature) {
            if (signature === undefined)
                return null;
            var signingText = signature.content;
            if (typeof signingText != 'undefined' && signingText) {
                var contentDraftBlock = htmlToDraft(signingText);
                if (contentDraftBlock) {
                    var contentState = ContentState.createFromBlockArray(contentDraftBlock.contentBlocks);
                    return EditorState.createWithContent(contentState);
                }
            }
            return EditorState.createEmpty();
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            var wrapperClassName = (caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning) ? 'text-editor-wrapper' : 'text-editor-wrapper-readonly';
            var labelId = 'idSignatureSelector';
            var label = 'Select or add signature';
            var signatures = (_b = this.props.signingStore) === null || _b === void 0 ? void 0 : _b.parseSignatures(caseType === null || caseType === void 0 ? void 0 : caseType.signingText);
            var selectedSignature = signatures === null || signatures === void 0 ? void 0 : signatures.find(function (s) { return s.name === _this.state.selectedSignatureName; });
            var options = signatures === null || signatures === void 0 ? void 0 : signatures.map(function (s) { return _jsx(MenuItem, __assign({ value: s.name }, { children: s.name }), s.name); });
            var signatureSettings = !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning) || !selectedSignature
                ? null
                : (_jsxs(Grid, __assign({ container: true, columnSpacing: 2, alignItems: "center", width: "100%" }, { children: [_jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx(TextField, { variant: "outlined", fullWidth: true, InputLabelProps: { shrink: true }, inputProps: { maxLength: 50 }, onChange: function (e) { return _this.onSignatureNameChanged(e); }, value: selectedSignature.name, label: "Title", required: true }, void 0) }), void 0), _jsx(Grid, __assign({ item: true }, { children: _jsx(FormControlLabel, { label: "Enable signature with value", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: selectedSignature.isPlaceholderEnabled, onChange: function (e) { return _this.onSigningWithPlaceholderChange(e); } }, void 0) }, void 0) }), void 0), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ variant: "outlined", disabled: !selectedSignature.isPlaceholderEnabled, onClick: function () { return _this.onInsertPlaceholderClick(); } }, { children: "Append placeholder" }), void 0) }), void 0)] }), void 0));
            var editor = !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning) || !this.state.signatureEditorState
                ? null
                : (_jsx(Editor, { readOnly: !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning), editorState: this.state.signatureEditorState, wrapperClassName: wrapperClassName, editorClassName: "text-editor", toolbar: {
                        options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'history', 'link'],
                        inline: { inDropdown: true },
                        list: { inDropdown: true },
                        textAlign: { inDropdown: true },
                        link: {
                            inDropdown: false,
                            showOpenOptionOnHover: true,
                            defaultTargetOption: '_blank',
                            options: ['link', 'unlink']
                        },
                        history: { inDropdown: true }
                    }, onEditorStateChange: function (state) { return _this.onEditorStateChange(state); } }, void 0));
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2 }, { children: [_jsx(FormLabel, { children: _jsx("h4", { children: "Signature Settings" }, void 0) }, void 0), _jsxs(Grid, __assign({ container: true, columnSpacing: 2, alignItems: "center", width: "100%" }, { children: [_jsx(Grid, __assign({ item: true, sx: { paddingLeft: '0 !important' } }, { children: _jsx(FormControlLabel, { label: "Enable signature", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning, onChange: function (e) { return _this.onEnableSignature(e); } }, void 0) }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2 }, { children: _jsxs(FormControl, __assign({ fullWidth: true, variant: "outlined" }, { children: [_jsx(InputLabel, __assign({ id: labelId }, { children: label }), void 0), _jsx(Select, __assign({ labelId: labelId, value: this.state.selectedSignatureName, label: label, disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning) || !signatures || signatures.length === 0, onChange: function (e) { return _this.onSelectedSignatureChanged(e); } }, { children: options }), void 0)] }), void 0) }), void 0), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ variant: "outlined", disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning), onClick: function () { return _this.onAddSignature(); } }, { children: _jsx(AddCircleIcon, {}, void 0) }), void 0) }), void 0), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ variant: "outlined", disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.enableSigning) || !signatures || signatures.length === 0, onClick: function () { return _this.onRemoveSignature(); } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0) }), void 0)] }), void 0), signatureSettings, editor] }), void 0));
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onAddSignature", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _c, _d, _e;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!currentCaseType)
                return;
            var signatures = (_b = this.props.signingStore) === null || _b === void 0 ? void 0 : _b.parseSignatures(currentCaseType.signingText);
            if (!signatures)
                return;
            var newSignature = {
                name: 'Signature ' + ((signatures === null || signatures === void 0 ? void 0 : signatures.length) + 1),
                content: '',
                isPlaceholderEnabled: false
            };
            signatures.push(newSignature);
            var updatedCaseType = __assign(__assign({}, currentCaseType), { signingText: (_d = (_c = this.props.signingStore) === null || _c === void 0 ? void 0 : _c.stringifySignatures(signatures)) !== null && _d !== void 0 ? _d : '' });
            (_e = this.props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.updateCaseType(updatedCaseType);
            this.setState(__assign(__assign({}, this.state), { selectedSignatureName: newSignature.name, signatureEditorState: this.getEditorState(newSignature) }));
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onRemoveSignature", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!currentCaseType)
                return;
            var signatures = (_b = this.props.signingStore) === null || _b === void 0 ? void 0 : _b.parseSignatures(currentCaseType.signingText);
            if (!signatures)
                return;
            var index = signatures.findIndex(function (s) { return s.name === _this.state.selectedSignatureName; });
            if (index === -1)
                return;
            signatures.splice(index, 1);
            var updatedCaseType = __assign(__assign({}, currentCaseType), { signingText: (_d = (_c = this.props.signingStore) === null || _c === void 0 ? void 0 : _c.stringifySignatures(signatures)) !== null && _d !== void 0 ? _d : '' });
            (_e = this.props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.updateCaseType(updatedCaseType);
            var selectedSignature = signatures.length > 0 ? signatures[0] : undefined;
            this.setState(__assign(__assign({}, this.state), { selectedSignatureName: (_f = selectedSignature === null || selectedSignature === void 0 ? void 0 : selectedSignature.name) !== null && _f !== void 0 ? _f : '', signatureEditorState: this.getEditorState(selectedSignature) }));
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onSignatureNameChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _this = this;
            var _a, _b, _c, _d, _e;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!currentCaseType)
                return;
            var signatures = (_b = this.props.signingStore) === null || _b === void 0 ? void 0 : _b.parseSignatures(currentCaseType.signingText);
            var selectedSignature = signatures === null || signatures === void 0 ? void 0 : signatures.find(function (s) { return s.name === _this.state.selectedSignatureName; });
            if (selectedSignature) {
                var existingSignature = signatures === null || signatures === void 0 ? void 0 : signatures.find(function (s) { return s.name === e.target.value; });
                if (existingSignature && existingSignature !== selectedSignature)
                    return;
                selectedSignature.name = e.target.value;
                this.setState(__assign(__assign({}, this.state), { selectedSignatureName: selectedSignature.name }));
                var updatedCaseType = __assign(__assign({}, currentCaseType), { signingText: (_d = (_c = this.props.signingStore) === null || _c === void 0 ? void 0 : _c.stringifySignatures(signatures)) !== null && _d !== void 0 ? _d : '' });
                (_e = this.props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onSigningWithPlaceholderChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _this = this;
            var _a, _b, _c, _d, _e;
            var currentCaseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!currentCaseType)
                return;
            var signatures = (_b = this.props.signingStore) === null || _b === void 0 ? void 0 : _b.parseSignatures(currentCaseType.signingText);
            var selectedSignature = signatures === null || signatures === void 0 ? void 0 : signatures.find(function (s) { return s.name === _this.state.selectedSignatureName; });
            if (selectedSignature) {
                selectedSignature.isPlaceholderEnabled = e.target.checked;
                this.setState(__assign(__assign({}, this.state), { selectedSignatureName: selectedSignature.name }));
                var updatedCaseType = __assign(__assign({}, currentCaseType), { signingText: (_d = (_c = this.props.signingStore) === null || _c === void 0 ? void 0 : _c.stringifySignatures(signatures)) !== null && _d !== void 0 ? _d : '' });
                (_e = this.props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onSelectedSignatureChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var selectedSignature = this.getSignature(e.target.value);
            if (selectedSignature) {
                this.setState(__assign(__assign({}, this.state), { selectedSignatureName: selectedSignature.name, signatureEditorState: this.getEditorState(selectedSignature) }));
            }
            else {
                this.setState(__assign(__assign({}, this.state), { selectedSignatureName: '', signatureEditorState: null }));
            }
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "getSignature", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            var _a, _b, _c, _d;
            return (_d = (_a = this.props.signingStore) === null || _a === void 0 ? void 0 : _a.parseSignatures((_c = (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseType) === null || _c === void 0 ? void 0 : _c.signingText)) === null || _d === void 0 ? void 0 : _d.find(function (s) { return s.name === name; });
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onEnableSignature", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { enableSigning: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onEditorStateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (editorState) {
            var _this = this;
            var _a, _b, _c, _d, _e;
            this.setState(__assign(__assign({}, this.state), { signatureEditorState: editorState }));
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!caseType)
                return;
            var signatures = (_b = this.props.signingStore) === null || _b === void 0 ? void 0 : _b.parseSignatures(caseType.signingText);
            var selectedSignature = signatures === null || signatures === void 0 ? void 0 : signatures.find(function (s) { return s.name === _this.state.selectedSignatureName; });
            if (!selectedSignature)
                return;
            selectedSignature.content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            var updatedCaseType = __assign(__assign({}, caseType), { signingText: (_d = (_c = this.props.signingStore) === null || _c === void 0 ? void 0 : _c.stringifySignatures(signatures)) !== null && _d !== void 0 ? _d : '' });
            (_e = this.props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.updateCaseType(updatedCaseType);
        }
    });
    Object.defineProperty(SignatureSettingsEditor.prototype, "onInsertPlaceholderClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var editorState = this.state.signatureEditorState;
            if (!editorState)
                return;
            var selection = editorState.getSelection();
            var contentState = editorState.getCurrentContent();
            var ncs = Modifier.insertText(contentState, selection, "{value}");
            var newEditorState = EditorState.push(editorState, ncs, 'insert-fragment');
            this.setState(__assign(__assign({}, this.state), { signatureEditorState: newEditorState }));
        }
    });
    SignatureSettingsEditor = __decorate([
        inject('caseTypesStore'),
        inject('signingStore'),
        inject('languageStore'),
        observer
    ], SignatureSettingsEditor);
    return SignatureSettingsEditor;
}(React.Component));
export default SignatureSettingsEditor;
